import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const FAQSectionHTAG = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Pour qui sont vos services ?',
      answer: 'Nos services professionnels s\'adressent aux TPE, PME, associations et indépendants souhaitant transformer leur présence numérique et optimiser leurs outils informatiques.',
    },
    {
      question: 'Et pour les particuliers ?',
      answer: 'Une page dédiée existe pour l\'assistance aux particuliers (installation d\'ordinateur, aide à la configuration, assistance fibre, dépannage). Cliquez sur "Particuliers" dans le menu.',
    },
    {
      question: 'Comment se déroule un engagement ?',
      answer: 'Nous commençons par un audit gratuit de votre situation, puis nous établissons un devis précis. Suivent l\'implémentation, le suivi régulier et l\'accompagnement post-projet pour assurer votre réussite.',
    },
    {
      question: 'Quels sont les délais ?',
      answer: 'Les délais varient selon le projet : de quelques jours pour une assistance urgente à plusieurs mois pour une refonte complète. Nous vous fournissons un calendrier détaillé lors du devis.',
    },
    {
      question: 'Intervenez-vous à distance ou sur site ?',
      answer: 'Nous proposons les deux : assistance par visio et screen share pour le dépannage, les ateliers et le coaching; et interventions physiques à Château-Porcien ou en deplacement national pour les installations fibre et les projets complexes.',
    },
    {
      question: 'Quel est le suivi après le projet ?',
      answer: 'Nous assurons un suivi régulier et nous restons disponibles pour questions et ajustements. Des retours d\'expérience trimestriels permettent d\'optimiser continuellement vos outils et processus.',
    },
    {
      question: 'Proposez-vous des contrats de maintenance ?',
      answer: 'Oui, nous proposons des formules de support mensuel ou annuel (maintenance, helpdesk, mises à jour) adaptées à votre taille et vos besoins spécifiques.',
    },
    {
      question: 'Comment fonctionnent vos tarifs ?',
      answer: 'Nos tarifs sont sur mesure et transparents. Un devis gratuit et détaillé vous permet de connaître l\'investissement exact. Pas de surprise, juste de la clarté.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#181C25] via-[#212635] to-[#181C25]">
      <div className="container mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl lg:text-5xl font-montserrat font-bold text-white mb-6">
            Questions <span style={{ color: '#0090FF', textShadow: '0 0 20px rgba(0, 144, 255, 0.3)' }}>Fréquentes</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Tout ce que vous devez savoir sur nos services
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="rounded-lg bg-gradient-to-br from-gray-800 to-gray-900 border border-gray-700 hover:border-blue-500 transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-800/50 transition-colors"
              >
                <h3 className="font-montserrat font-bold text-white text-lg">
                  {faq.question}
                </h3>
                <motion.div
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <ChevronDown className="w-5 h-5 text-gray-400" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="px-6 pb-4 text-gray-400 leading-relaxed">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSectionHTAG;
